






























































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import UiSelectStatus from '@/components/UI/select-status.vue';
import { getTranscriptionStatus } from '@/helpers/validateTranscriptionStatus';
import * as serviceDoctor from '@/services/doctors';
import * as servicePatient from '@/services/patients';
import * as servicePrescription from '@/services/prescription';
import { getLocalUser } from '@/services/session-data';
import * as TRANSCRIPTION_STATUS from '@/settings/consts/transcription-status';
import { isXsOrSmSizeScreen } from '@/subjects/resize';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { getServerISODate } from '../../../helpers/dateFormat';


@Component({
  components: {
    UiAutocompleClientsSubsidiaries,
    UiDatePicker,
    UiSelectStatus,
    UiSelectDoctor,
    UiDatePickerRange
  },
})
export default class PrescriptionListTranscriptionFilters extends BaseComponent {
  @Prop(Boolean)
  public hideStatus?: boolean;
  @Prop(Boolean)
  public hideClient?: boolean;
  @Prop()
  public reloadPatientWatch?: any;

  public doctorLoading: boolean = false;
  public patientLoading: boolean = false;
  public doctors: any = [];
  public patients: any = [];

  public search: any = {
    id: null,
    idOld: null,
    patientId: null,
    doctorId: null,
    hospitalUnit: null,
    productionDate: [null, null],
    prescriptionDate: [getServerISODate(), getServerISODate()],
    prescriptionCreatedDate: [null, null],
    typeTranscription: null,
    multi: null,
    transcriptionStatus: [
      TRANSCRIPTION_STATUS.WAITING_TRANSCRIPTION.key,
      TRANSCRIPTION_STATUS.WAITING_TRANSCRIPTION_APPROVE.key,
      TRANSCRIPTION_STATUS.TRANSCRIPTION_ERROR_ON_SEND_TO_PRODUCTION.key,
      TRANSCRIPTION_STATUS.SCHEDULED_PRODUCTION.key,
      TRANSCRIPTION_STATUS.TRANSCRIPTION_APPROVED.key,
      TRANSCRIPTION_STATUS.TRANSCRIPTION_DENIED.key,
      TRANSCRIPTION_STATUS.CANCELED_IN_PRODUCTION.key
    ],
  };

  public multiOptions = [
    {id: null, label: "Todos"}, 
    {id: false, label: "Comum"}, 
    {id: true, label: "Multicompartimentada"}
  ];

  public expand = 0;  

  get statusList(): any[] {
    return getTranscriptionStatus();
  }

  @Watch('reloadPatientWatch') 
  public reloadPatientWatchChange(){
    this.getPatient();
  }

  @Watch('search.hospitalUnit')
  public onChangeHospitalUnit(): void {
    this.search.doctorId = null;
    if (!this.isEmede()) {
      this.getPatient();
      this.getDoctors();
    }
  }

  public onChangeStatus(listaStatus) {
     this.search.transcriptionStatus = listaStatus;
     this.onChangeSearch();
  }

  public onChangeSearch() {
    const unitAndDoctorIsSelected = () => {
      return (
        !this.isEmede() &&
        !!this.search.hospitalUnit &&
        !!this.search.hospitalUnit.id &&
        this.isDoctor() &&
        !!this.search.doctorId
      );
    };

    if (this.isEmede() || !this.isDoctor() || unitAndDoctorIsSelected()) {
      this.search.idOld = this.search.id;
      setTimeout(() => {
        this.$emit('filter', this.search);        
      }, 300);
    }
  }

  public beforeMount() {
    this.load();
  }

  public mounted() {
    this.expand = isXsOrSmSizeScreen() ? null : 0;
    this.onChangeSearch();
  }

  public showDoctorFilter(): boolean {
    return !this.isDoctor();
  }

  public load() {
    this.getPatient();
    this.getDoctors();

    if (this.isDoctor()) {
      getLocalUser().subscribe((currentUser) => {
        this.search.doctorId = currentUser.id;
      });
      this.onChangeSearch();
    }
  }

  public getPatient(): void {
    this.search.patient = null;
    this.patients = [];

    let getPatients;
    if (this.isEmede()) {
      getPatients = servicePatient.getPatientsCombo();
    } else if (!!this.search.hospitalUnit && !!this.search.hospitalUnit.id) {
      getPatients = servicePrescription.listPrescriptionPatientsCombo(
        this.search.hospitalUnit.id, true
      );
    }

    if (!!getPatients) {
      this.patientLoading = true;
      getPatients.subscribe((r) => {
        this.patientLoading = false;
        this.patients = r.map((item) => {
          return {
            ...item,
            setor: item.setor || '',
            leito: item.leito || '',
            same: item.same || '',
            termo: item.termo || null,
          };
        });
      });
    }
  }

  public getDoctors(): void {
    this.search.doctor = null;
    this.doctors = [];

    let getDoctors;
    if (this.isEmede()) {
      getDoctors = serviceDoctor.getLeanDoctors();
    } else if (!!this.search.hospitalUnit && !!this.search.hospitalUnit.id) {
      getDoctors = serviceDoctor.getClientDoctors(this.search.hospitalUnit.id);
    }

    if (!!getDoctors) {
      this.doctorLoading = true;
      getDoctors.subscribe((r) => {
        this.doctors = r;
        this.doctorLoading = false;
      });
    }
  }
}
